module.exports = __webpack_public_path__ + "static/media/s700_Better.8fa3173a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/s700_Better.jpg
// module id = 217
// module chunks = 0